/** The one place the Interaction Detail path is built: redirect and every list row. */
export function interactionPathFor(sessionId: string): string {
  return `/interactions/${encodeURIComponent(sessionId)}`;
}
